import {Label} from '@fluentui/react';
import {useMemo} from 'react';
import {sortByTitle} from '../../../../helpers/arrayMehods';
import {HeadingWithDecoration} from '../../../common/HeadingWithDecoration';
import {LastEditor} from '../../../common/LastEditor';
import {Subscription} from '../../../common/Subscription';
import {ProcessDescriptions} from '../components/ProcessDescriptions';
import {ProcessDiagram} from '../components/ProcessDiagram';
import {ProcessDocuments} from '../components/ProcessDocuments';
import {ProcessExternalLinks} from '../components/ProcessExternalLinks';
import {ProcessOwner} from '../components/ProcessOwner';
import {ProcessWrapper} from '../components/Wrapper';
import styles from '../Process.module.scss';
import {useProcess} from './useProcess';
import {ProcessActivities} from '../components/ProcessActivities';
import {ProcessVersionHistory} from '../components/VersionHistory';
import {SendEmail} from '../components/SendEmail';
import {DictionaryPill} from '../../../common/DictionaryPill';
import {Feedback} from '../components/Feedback/Feedback';
import {Helmet} from 'react-helmet';

export const Process = () => {
  const {isLoading, process, canEditProcess, canEditDiagram, helmetTitle, publishedProcessesForUnit} =
    useProcess();
  const nextUpdate = process?.nextUpdate ? process?.nextUpdate.split('T')[0] : undefined;
  const isMirrorCopy = process?.isMirrorCopy;
  const externalLinks = useMemo(() => process?.externalLinks?.sort(sortByTitle) || null, [process]);



  return (
    <ProcessWrapper
      apiMsg={''}
      isLoading={isLoading}
      process={process}
      canEditProcess={canEditProcess}
      publishedProcessesForUnit={publishedProcessesForUnit}>
      {process ? (
        <>
          {helmetTitle && (
            <Helmet>
              <title>{helmetTitle}</title>
            </Helmet>
          )}
          <HeadingWithDecoration showIcon={process.isOutdated} tooltipText='This page has not been validated, and may contain outdated or inaccurate information. Use only after consulting the owner of this page' iconName='Warning' text={process.title || ''} />
          <div className={styles.processMetaWrapper}>
            <div className={styles.processMeta}>
              {process.processOwner ? <ProcessOwner processOwner={process.processOwner} /> : null}
              <SendEmail
                unitId={process.unit?.id || 0}
                processId={process.id}
                processTitle={process.title || ''}
                processOwner={process.processOwner || undefined}
              />
              <Subscription processId={process.id} />
              {isMirrorCopy ? (
                  <>
                    <Label className={styles.mirrorcopy}>Mirror copy</Label>
                  </>
                ) : null}
              <div className={styles.update}>
                {nextUpdate ? (
                  <>
                    <Label>Next process update:</Label> {nextUpdate}
                  </>
                ) : null}
              </div>
            </div>
            <LastEditor
              personData={process?.modifiedBy?.azureId}
              whenEdited={process.modified || ''}
              whenPublished={process.published || ''}
            />
            <DictionaryPill label="Function" value={process.function} />
            <DictionaryPill label="Project Size Category" value={process.projectSizeCategories} />
            <DictionaryPill label="Industry" value={process.industries} />
            <DictionaryPill label="Speciality" value={process.specialities} />
            
          </div>
          <ProcessDiagram
            processId={process.id}
            processTitle={process.title || ''}
            unitId={process.unit?.id || 0}
            canEdit={canEditDiagram && !isMirrorCopy}
          />
          <ProcessDescriptions process={process} processUnitTitle={process.unit?.title || ''} />
          <ProcessDocuments documents={process.documents} />
          <ProcessExternalLinks externalLinks={externalLinks} />
          <ProcessActivities
            activities={process.activityInputs}
            isInput
            unitId={process.unit?.id || 0}
          />
          <ProcessActivities
            activities={process.activityOutputs}
            isInput={false}
            unitId={process.unit?.id || 0}
          />
          <ProcessVersionHistory processId={process.id} />
          <Feedback process={process} unitId={process.unit?.id || 0} />
        </>
      ) : null}
    </ProcessWrapper>
  );
};
